import get from 'lodash.get';
import { customFieldCategory, GENERAL_FORMBUILDER_PATH, nodeTypes, oldCustomFieldCategory } from '../constants/formbuilder';

export const hasFormbuilderQuestions = (formbuilderModel) => {
    const questions = get(formbuilderModel, 'children.0.children');

    return questions !== undefined && questions.length !== 0;
}

export const getFormbuilderQuestions = (formbuilderModel) => {
    return get(formbuilderModel, 'children.0.children') || [];
}

export const getQuestionsFromModel = (modelWithQuestions, fieldCategoryKey) => {
    if (!modelWithQuestions || !fieldCategoryKey) {
        return;
    }

    return get(modelWithQuestions, `${GENERAL_FORMBUILDER_PATH}.${customFieldCategory[fieldCategoryKey]}`) ||
        get(modelWithQuestions, `${GENERAL_FORMBUILDER_PATH}.${oldCustomFieldCategory[fieldCategoryKey]}`);
}

export const getCustomFields = formbuilderAnswers => {
    if (!formbuilderAnswers) {
        return null;
    }

    // TODO: check on children
    const customFields = formbuilderAnswers.children[0].children.map(item => {
        if (item.type === nodeTypes.ADDRESS || item.type === nodeTypes.PHONE || item.type === nodeTypes.GROUP_DIVIDER) {
            return undefined;
        }

        const isHidden = getGroupVisibility(formbuilderAnswers, item.props.groupIdentifier);
        if (isHidden) {
            return {
                identifier: item.identifier
            }
        }

        return {
            identifier: item.identifier,
            value: Array.isArray(item.answer) ? item.answer.join(',') : item.answer
        }
    });

    return customFields && customFields.length ? customFields.filter(x => x !== undefined) : undefined;
}

export const getGroupVisibility = (formBuilderAnswers, groupIdentifier) => {
    if (!groupIdentifier) {
        return;
    }

    const formbuilderQuestions = getFormbuilderQuestions(formBuilderAnswers);
    const group = formbuilderQuestions.find(x => x.type === nodeTypes.GROUP_DIVIDER);

    return group.answer;
}

export const getPhoneNumberFromFormbuilderAnswers = (formBuilderAnswers) => {
    if (!formBuilderAnswers || !hasFormbuilderQuestions(formBuilderAnswers)) {
        return undefined;
    }

    const formbuilderQuestions = getFormbuilderQuestions(formBuilderAnswers);
    const phone = formbuilderQuestions.find(x => x.type === nodeTypes.PHONE);

    if (!phone || !phone.answer) {
        return undefined;
    }

    const isHidden = getGroupVisibility(formBuilderAnswers, phone.props.groupIdentifier);
    if (isHidden) {
        return undefined;
    }

    return phone.answer;
}

export const getAddressModelFromFormbuilderAnswers = (formBuilderAnswers) => {
    if (!formBuilderAnswers || !hasFormbuilderQuestions(formBuilderAnswers)) {
        return undefined;
    }

    const formbuilderQuestions = getFormbuilderQuestions(formBuilderAnswers);
    const address = formbuilderQuestions.find(x => x.type === nodeTypes.ADDRESS);

    if (!address || !address.answer) {
        return undefined;
    }

    const isHidden = getGroupVisibility(formBuilderAnswers, address.props.groupIdentifier);
    if (isHidden) {
        return undefined;
    }

    const { suburb, street, state, postCode, country } = address.answer;

    return {
        city: suburb,
        street: street,
        state: state,
        postcode: postCode,
        country: country
    }
}

export const getMappedAddress = (address) => {
    if (!address) {
        return null;
    }

    const { suburb, street, state, postCode, country } = address;

    return {
        city: suburb,
        street: street,
        state: state,
        postcode: postCode,
        country: country
    };
}